var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal"},[_c('span',{staticClass:"close cursor-pointer",on:{"click":_vm.close}},[_vm._v("×")]),_c('b-img',{staticClass:"modal-content-img",attrs:{"src":_vm.image},on:{"click":_vm.close}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }